import React from 'react';
import { Link } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import logo from '../../assets/layerx-logo.svg';


import Nav from './Nav';

function Header() {

  return (
    <header>
      <AppBar position="static">
        <Toolbar sx={{ background: 'white' }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Link to="/">
              <Box component='img' alt="Layer X Logo" src={logo} sx={{ height: '32px', marginRight: '16px' }}/>
              <Typography variant='h1' sx={{ color: '#007bff', fontSize: 32, display: 'inline-block' }}>Layer X</Typography>
            </Link>
            <Nav />
          </Stack>
        </Toolbar>
      </AppBar>
    </header>
  );
}

export default Header;